import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 120,
	viewBox: "0 0 170 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_26098_31347)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M38.9168 89.3296C38.9168 92.8883 41.8058 95.7732 45.3696 95.7732H123.694C127.258 95.7732 130.147 92.8883 130.147 89.3296V30.6704C130.147 27.1117 127.258 24.2268 123.694 24.2268H45.3696C41.8058 24.2268 38.9168 27.1117 38.9168 30.6704V89.3296ZM45.3696 102.439C38.1191 102.439 32.2414 96.5697 32.2414 89.3296V30.6704C32.2414 23.4303 38.1191 17.561 45.3696 17.561H123.694C130.945 17.561 136.823 23.4303 136.823 30.6704V89.3296C136.823 96.5697 130.945 102.439 123.694 102.439H45.3696Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M113.907 68.2234C112.064 68.2234 110.57 66.7311 110.57 64.8905V55.1138C110.57 53.2731 112.064 51.781 113.907 51.781C115.751 51.781 117.245 53.2731 117.245 55.1138V64.8905C117.245 66.7311 115.751 68.2234 113.907 68.2234Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 22.1341L2.84127 19.297L8.06034 24.4885V14.0854C8.06451 10.351 9.55196 6.77072 12.1964 4.13009C14.8409 1.48948 18.4262 0.00415424 22.1659 0H32.2414V4.02439H22.1659C19.4947 4.02742 16.9338 5.0884 15.0449 6.97453C13.156 8.86067 12.0936 11.418 12.0905 14.0854V24.4885L17.3097 19.297L20.1509 22.1341L10.0754 32.1951L0 22.1341Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M169.062 97.8658L166.22 100.703L161.002 95.5115V105.915C160.997 109.649 159.51 113.229 156.866 115.87C154.221 118.511 150.636 119.996 146.896 120H136.821V115.976H146.896C149.568 115.973 152.128 114.912 154.017 113.026C155.906 111.139 156.969 108.582 156.972 105.915V95.5115L151.753 100.703L148.911 97.8658L158.987 87.8049L169.062 97.8658Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_26098_31347",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 170,
			height: 120,
			fill: "currentColor"
		})
	}) })]
});
export default SvgRotate;
